import { AppState } from "../../state";
import { createSelector } from "reselect";

export const getEnrolmentState = (state: AppState) => (state.enrolment.status === "enroled" ? state.enrolment : null);

export const getCanBypassStaffLogin = createSelector(
    getEnrolmentState,
    (enroled) => enroled?.can_bypass_staff_login ?? false
);
